import * as actionTypes from './actionTypes';


export const manageCookieConsent = (consent) => ({
    type: actionTypes.COOKIES_CONSENT,
    consent
});
